
import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { EndpointFactory } from '../endpoint-factory.service';
import { ConfigurationService } from '../../services/Common/configuration.service';
import { ApiResponse } from '@app/shared/models/Common/apiresponse.model';
import * as AspNetData from "devextreme-aspnet-data-nojquery";
import CustomStore from "devextreme/data/custom_store";
import { DBkeys } from '../../services/db-Keys';
import { QuotationPolicyHolder } from '@app/shared/models/business/quotation.policyholder.model';
import { IndQuotationPolicyHolder, MembersGrossPremiumList } from '@app/shared/models/business/indquotation.policyholder.model';
import notify from 'devextreme/ui/notify';
import { NotificationService } from '../../services';
import { Product } from '@app/shared/models/business/product';
import { QuotationApprovalRequest } from '@app/shared/models/business/quotation.approvalrequest';
import { QuotationDocument } from '@app/shared/models/business/quotation.document';
import { QuotationApprovalComment } from '@app/shared/models/business/quotation.approvalcomment';
import { BenefitPlansDto } from '@app/shared/models/business/quotation.benefit.plans';
import { ProductCategoryRule } from '@app/shared/models/business/quotation.productcatrule.model ';
import { IndicativePremiumSummary } from '@app/shared/models/business/quotation.indicativebreakup.model';
@Injectable()
export class HealthQuotationEndpoint extends EndpointFactory {

  private readonly _businessSectorUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Quotation/getbusinesssectors`;
  private readonly _initQuotationUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Quotation/initquotation`;
  private readonly _initIndQuotationUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Quotation/initindquotation`;
  private readonly _getPolicyHolderUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Quotation/getquotationpolicyholder`;
  private readonly _getIndQuotationUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Quotation/getindquotation`;
  private readonly _getIndQuotationWithPremiumUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Quotation/getIndQuotationWithPremium`;
  private readonly _getIndQuotationMemberRemarksUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/memberRemark/getIndQuotationMemberRemarks`;
  private readonly _editPolicyHolderUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Quotation/initquotation`;
  private readonly _editIndPolicyHolderUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Quotation/initquotation`;
  private readonly _getGovernorateListUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Quotation/getgovernorates`;
  private readonly _getQuotationBenefitUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/benefit/getquotationbenefit`;
  private readonly _getIndQuotationBenefitUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/benefit/getindquotationbenefit`;
  private readonly _getBenefitsForComparision: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/benefit/getbenefitscomparision`;
  private readonly _getPolicyHolderListUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Quotation/getpolicyholderlist`;
  private readonly _getHistoricalQuoteListUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Quotation/gethistoricalquotelist`;
  private readonly _getBusinessEntitiesUrl: string = `${this.configurations.baseUrl}${this.configurations.smartSuffix}/api/idp/Shared/getbusinessentities`;
  private readonly _getAllQuotationsUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/report/getquotationlist`;
  private readonly _getFilterAllQuotationsUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/report/getFilterquotationlist`;
  private readonly _getPendingQuotationsUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/report/getpendingquotations`;
  private readonly _getFilterPendingQuotationsUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/report/getFilterpendingquotations`;
  private readonly _getDraftQuotationsUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/report/getdraftquotations`;
  private readonly _getFilterDraftQuotationsUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/report/getFilterdraftquotations`;
  private readonly _getQuotationTaskAssignmentUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Quotation/gettaskassignment`;
  private readonly _submitQuotationTaskAssignmentUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Quotation/submittaskassignment`;
  private readonly _downloadPremuimDocUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/report/downloadpremium`;
  private readonly _downloadPremiumTobDocUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/report/downloadpremiumtob`;
  private readonly _downloadRiderTPADocUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/report/exportridertpa`;
  private readonly _downloadDefPremiumDocUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/report/downloaddocbytypebyfile`;
  private readonly _downloadDocUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/report/downlaoddoc`;
  private readonly _downloadMafDocUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/report/downlaodMAFdoc`;
  private readonly _downlaodMAFMemberdocUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/report/downlaodMAFMemberdoc`;
  private readonly _downloadExcelPremiumUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/report/exportpremiumexcel`;
  private readonly _uploadMiscDocsUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/uploadmiscdoc`;
  private readonly _downloadTOBDocUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/report/downloadtob`;
  private readonly _exportClaimInfoUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Quotation/exportclaim`;
  private readonly _createNewOptionUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Quotation/createnewoption`;
  private readonly _quotingInsurerListUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Quotation/getquotinginsurerlist`;
  private readonly _quotingIndividualInsurerListUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/indquotation/getquotinginsurerlist`;
  private readonly _quotingTPAListUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Quotation/getquotingtpalist`;
  private readonly _existingTPAListUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Quotation/getexistingtpalist`;
  private readonly _quotationLoadingUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Quotation/getquotationloading`;
  private readonly _submissionElementsUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Quotation/getsubmissionelements`;
  private readonly _submitQuotationUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Quotation/submitforapproval`;
  private readonly _createHealthLifeQuotationUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Quotation/createhealthlifequotation`;
  private readonly _submitQuotationWithLoadUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/submitforapprovalwithload`;
  private readonly _getProductsUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/benefit/getproducts`;
  private readonly _getProductsByTenantUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/benefit/getProductsByTenantId`;
  private readonly _getInsurerProductsUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/benefit/getinsurerproducts`;
  private readonly _submitClaimExpUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/amendclaimexp`;
  private readonly _getClaimExpUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/getclaimexp`;
  private readonly _getApprovalRequestUrl = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/getapprovalrequest`;
  private readonly _getInsurerApprovalRequestUrl = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/getinsurerapprovalrequest`;
  private readonly _getQuotationPremiumSummaryUrl = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/getquotationpremiumsummary`;
  private readonly _generateQuotationPremiumSummaryUrl = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/generatequotationpremiumsummary`;
  private readonly _generateQuotationSOBTrackerUrl = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/generatequotationsobtracker`;
  private readonly _updatecategoryloadingsUrl = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/updatecategoryloadings`;
  private readonly _generateQuotationTechnicalSheetUrl = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/generatequotationtechnicalsheet`;
  private readonly _submitApprovalDecisionUrl = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/approvequotation`;
  private readonly _submitInsurerApprovalDecisionUrl = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/insurerapprovequotation`;
  private readonly _getIndicativePremiumUrl = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/getindicativepremium`;
  private readonly _getQuotationDetailEndpointUrl = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/getquotationdetail`;
  private readonly _getMemberQuotationDocumentsByTypeUrl = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/report/getmemberquotationdoctypelist`;
  private readonly _getIndicativePremiumApproverUrl = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/getindicativepremiumforapprover`;
  private readonly _getquotationDocumentsUrl = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/report/getquotationdoclist`;
  private readonly _getquotationDocsByTypeUrl = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/report/getquotationdoctypelist`;
  private readonly _getquotationClaimExpSummaryUrl = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/getquotationclaimexpsummary`;
  private readonly _uploadMembersdocUrl = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/uploadMembersdoc`;
  private readonly _getInsurerQuotationClaimExpSummaryUrl = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/getinsurerquotationclaimexpsummary`;
  private readonly _deleteDocumentUrl = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/deleteclaimdoc`;
  private readonly _deleteApprovalDocumentUrl = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/deleteapprovaldoc`;
  private readonly _deleteQuotationUrl = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/deletequotation`;
  private readonly _confirmQuotationUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Quotation/confirmquotation`;
  private readonly _checkNewOptionUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Quotation/checknewoption`;
  private readonly _lostQuotationUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Quotation/lostquotation`;
  private readonly _getNRPLoadingUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Quotation/getnrploading`;
  private readonly _getSubProductsUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Quotation/getsubproducts`;
  private readonly _getSubProductsMapUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Quotation/getsubproductsmap`;
  private readonly _getBenefitPlansUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/benefit/getbenefitplans`;
  private readonly _getProductCatRulesUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/benefit/getproductcatrules`;

  private readonly _getRegionsUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Quotation/getregions`;
  private readonly _getSubProductRegionMapUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Quotation/getsubproductsregionmap`;
  private readonly _regenerateQuotationDocUrl = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/refreshquotationdoc`;
  private readonly _chronicConditionValueUrl = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/getchronicvalues`;
  private readonly _chronicSubmLimitUrl = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/getchronicsublimits`;
  private readonly _updatechronicConditionUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/updatechroniccondition`;
  private readonly _quotationApprovalCommentUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/Quotation/getapprovalcomment`;
  private readonly _quoteChronicConditionUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/getchroniccondition`;
  private readonly _quotationOtherFeesUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/getquotationotherfees`;
  private readonly _documentTypeUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/shared/getdocumenttype`;
  private readonly _updateShortMAFUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/updateshortmaf`;
  private readonly _updateShortMAFConditionUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/updateshortmafcondition`;

  private readonly _updateMemberRemarksValuesUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/memberRemark/updateMemberRemarksValues`;
  private readonly _updateMemberRemarksByUWUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/memberRemark/UpdateMemberRemarksByUW`;
  private readonly _quoteShortMAFUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/getshortmaf`;  
  private readonly _quoteShortMAFReviewUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/getshortmafmemberreview`;

  private readonly _downloadZipUrl = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/report/downloadaszip`;
  private readonly _getsurveylinkUrl = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/QuotationAPI/getsurveylink`;
  private readonly _quoteCommentsUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/getquotecomment`;
  private readonly _overrideCommentsUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/getoverridecomment`;
  private readonly _getAgeBandPremiumPPUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/getoutputpremium`;

  private readonly _premiumFormatUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/getpremiumformat`;
  private readonly _escalateToReviewUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/escalatetoreview`;
  private readonly _tobParameterUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/report/`;
  private readonly _sharedgetuserrolesUrl: string = `${this.configurations.baseUrl}${this.configurations.smartSuffix}/api/idp/shared/getuserroles/`;
  private readonly _getquotationIndividualPlansUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/getquotationIndividualPlans`;
  private readonly _benefitValueSetUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/benefit/getbenefitvalueset`;
  private readonly _validateMafQuestionariesUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/quotation/validateMafQuestionaries`;
  private readonly _deleteMembersDocumentUrl = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/indquotation/deleteMembersDocument`;
  private readonly _getActivePlanDesignFactorsUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/benefit/getActivePlanDesignFactors`;
  private readonly _getFutureEffectivePlanDesignFactorsUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/benefit/getfutureEffectivePlanDesignFactors`;
  private readonly _getBrokerUserAuthorityListUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/shared/GetBrokerUserAuthorityList`;

  private readonly _savePlanDesignFactorRatesUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/benefit/saveplandesignfactorrates`;
  private readonly _deletePlanDesignFactorRateUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/benefit/deleteplandesignfactorrate`;
  private readonly _updatePlanDesignFactorRateUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/benefit/updateplandesignfactorrate`;
  private readonly _cancelFutureEffectivePlanDesignFactorsUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/benefit/cancelfutureeffectiveplandesignfactors`;

  // BaseRate endpoints
  private readonly _getActiveBaseRatesUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/benefit/getActiveBaseRates`;
  private readonly _saveBaseRatesUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/benefit/savebaserates`;
  private readonly _getFutureEffectiveBaseRatesUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/benefit/getfutureeffectivebaserates`;
  private readonly _cancelFutureEffectiveBaseRatesUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/benefit/cancelfutureeffectivebaserates`;
  private readonly _updateBaseRateUrl: string = `${this.configurations.baseUrl}${this.configurations.healthSuffix}/api/health/benefit/updatebaserate`;

  constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector, private notificationService: NotificationService) {
    super(http, configurations, injector);

    this.getAuthHeader_devextreme = this.getAuthHeader_devextreme.bind(this);
  }


  getbusinessSectorEndpoint<T>(tenantId?: number): Observable<T> {
    let endpointUrl = tenantId ? `${this._businessSectorUrl}/${tenantId}` : this._businessSectorUrl;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getbusinessSectorEndpoint(tenantId));
      }));
  }
  getIndQuotingInsurer(tenantId: number) {
    let endpointUrl = `${this._quotingIndividualInsurerListUrl}/${tenantId}`;

    return this.http.get(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getIndQuotingInsurer(tenantId));
      }));
  }
  getQuotingInsurer(tenantId: number) {
    let endpointUrl = `${this._quotingInsurerListUrl}/${tenantId}`;

    return this.http.get(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getQuotingInsurer(tenantId));
      }));
  }
  getQuotingTPA<T>(insurerId: number, productId: number = 0): Observable<T> {
    let endpointUrl = `${this._quotingTPAListUrl}/${insurerId}/${productId}`;

    return this.http.get(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getQuotingTPA(insurerId));
      }));
  }
  getExistingTPA<T>(): Observable<T> {
    let endpointUrl = `${this._existingTPAListUrl}`;

    return this.http.get(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getExistingTPA());
      }));
  }
  getGovernorateList<T>(): Observable<T> {
    let endpointUrl = `${this._getGovernorateListUrl}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => { return this.handleError(error, () => this.getGovernorateList()); }
      ));
  }
  getQuotationLoadingEndpoint<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._quotationLoadingUrl}?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getQuotationLoadingEndpoint(quotationId));
      }));
  }
  getQuotationOtherFeesEndPoint<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._quotationOtherFeesUrl}?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getQuotationOtherFeesEndPoint(quotationId));
      }));
  }

  submitForApprovalWithLoading<T>(obj: any): Observable<T> {
    return this.http.post(this._submitQuotationWithLoadUrl, JSON.stringify(obj), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.submitForApprovalWithLoading(obj));
      }));
  }
  getIndicativePremium<T>(obj: any): Observable<IndicativePremiumSummary> {
    return this.http.post(this._getIndicativePremiumUrl, JSON.stringify(obj), this.getRequestHeaders()).pipe<IndicativePremiumSummary>(
      catchError(error => {
        return this.handleError(error, () => this.getIndicativePremium(obj));
      }));
  }
  getIndicativePremiumForApprover<T>(obj: any): Observable<T> {
    return this.http.post(this._getIndicativePremiumApproverUrl, JSON.stringify(obj), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getIndicativePremiumForApprover(obj));
      }));
  }

  getSubmissionElements<T>(quotationId: number): Observable<any> {
    let endpointUrl = `${this._submissionElementsUrl}?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getSubmissionElements(quotationId));
      }));
  }
  getInitQuotationEndpoint<T>(quotationObject: any): Observable<T> {

    return this.http.post<T>(this._initQuotationUrl, JSON.stringify(quotationObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getInitQuotationEndpoint(quotationObject));
      }));
  }
  getInitIndQuotationEndpoint<T>(indquotationObject: any): Observable<T> {

    return this.http.post<T>(this._initIndQuotationUrl, JSON.stringify(indquotationObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getInitIndQuotationEndpoint(indquotationObject));
      }));
  }
  getEditPolicyHolderEndpoint<T>(formData: QuotationPolicyHolder): Observable<T> {
    return this.http.post(this._initQuotationUrl, JSON.stringify(formData), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getEditPolicyHolderEndpoint(formData));
      }));
  }
  getEditIndPolicyHolderEndpoint<T>(formData: IndQuotationPolicyHolder): Observable<T> {
    return this.http.post(this._initIndQuotationUrl, JSON.stringify(formData), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getEditIndPolicyHolderEndpoint(formData));
      }));
  }
  getPolicyHolderEndpoint(quotationId: number): Observable<QuotationPolicyHolder> {
    let endpointUrl = `${this._getPolicyHolderUrl}/${quotationId}`;

    return this.http.get(endpointUrl, this.getRequestHeaders()).pipe<QuotationPolicyHolder>(
      catchError(error => {
        return this.handleError(error, () => this.getPolicyHolderEndpoint(quotationId));
      }));
  }
  getIndQuotationEndpoint(quotationId: number): Observable<IndQuotationPolicyHolder> {
    let endpointUrl = `${this._getIndQuotationUrl}/${quotationId}`;

    return this.http.get(endpointUrl, this.getRequestHeaders()).pipe<IndQuotationPolicyHolder>(
      catchError(error => {
        return this.handleError(error, () => this.getPolicyHolderEndpoint(quotationId));
      }));
  }
  getIndQuotationWithPremium(quotationId: number): Observable<MembersGrossPremiumList[]> {
    let endpointUrl = `${this._getIndQuotationWithPremiumUrl}/${quotationId}`;

    return this.http.get(endpointUrl, this.getRequestHeaders()).pipe<MembersGrossPremiumList[]>(
      catchError(error => {
        return this.handleError(error, () => this.getIndQuotationWithPremium(quotationId));
      }));
  }
  getIndQuotationMemberRemarks(quotationId: number): Observable<MembersGrossPremiumList[]> {
    let endpointUrl = `${this._getIndQuotationMemberRemarksUrl}/${quotationId}`;

    return this.http.get(endpointUrl, this.getRequestHeaders()).pipe<MembersGrossPremiumList[]>(
      catchError(error => {
        return this.handleError(error, () => this.getIndQuotationMemberRemarks(quotationId));
      }));
  }

  submitForApprovalEndpoint<T>(quotationId: number): Observable<T> {
    return this.http.post<T>(this._submitQuotationUrl, JSON.stringify(quotationId), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.submitForApprovalEndpoint(quotationId));
      }));
  }
  createHealthLifeQuotationEndpoint<T>(quotationId: number): Observable<T> {
    return this.http.post<T>(this._createHealthLifeQuotationUrl, JSON.stringify(quotationId), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.createHealthLifeQuotationEndpoint(quotationId));
      }));
  }
  createNewOptionEndpoint<T>(quotationId: number): Observable<T> {
    return this.http.post<T>(this._createNewOptionUrl, JSON.stringify(quotationId), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.createNewOptionEndpoint(quotationId));
      }));
  }
  getQuotationBenefit<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._getQuotationBenefitUrl}/${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getQuotationBenefit(quotationId));
      }));
  }
  getPremiumFormat<T>(): Observable<T> {
    let endpointUrl = `${this._premiumFormatUrl}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getPremiumFormat());
      }));
  }
  getAllBenefitValues<T>(quotationId: number): Observable<T> {
    let endpointUrl = this._benefitValueSetUrl + `?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getAllBenefitValues(quotationId));
      }));
  }

  getIndQuotationBenefit<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._getIndQuotationBenefitUrl}/${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getIndQuotationBenefit(quotationId));
      }));
  }
  getBenefitsForComparision<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._getBenefitsForComparision}/${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getBenefitsForComparision(quotationId));
      }));

  }
  getProducts<T>(policyTypeId: number): Observable<T> {
    let endpointUrl = `${this._getProductsUrl}?typeId=${policyTypeId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getProducts(policyTypeId));
      }));

  }
  getProductsByTenantId<T>(tenantId: number): Observable<T> {
    let endpointUrl = `${this._getProductsByTenantUrl}?tenantId=${tenantId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getProductsByTenantId(tenantId));
      }));

  }

  getInsurerProducts<T>(id: number): Observable<T> {
    let endpointUrl = `${this._getInsurerProductsUrl}?id=${id}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getInsurerProducts(id));
      }));

  }
  getDocumentType<T>(): Observable<T> {
    const endpointUrl = this._documentTypeUrl;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getDocumentType());
      }));
  }
  uploadMiscDocumentEndpoint<T>(miscDocObject: any): Observable<T> {

    return this.http.post<T>(this._uploadMiscDocsUrl, miscDocObject, this.getDocRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.uploadMiscDocumentEndpoint(miscDocObject));
      }));
  }

  getQuotationDetailEndpoint<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._getQuotationDetailEndpointUrl}?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getQuotationDetailEndpoint(quotationId));
      }));
  }
  uploadMembersdocEndPoint<T>(fileProvider: any): Observable<T> {
    let endpointUrl = `${this._uploadMembersdocUrl}`;

    // var obj = {quotationId:quotationId,docId:docId}
    return this.http.post<T>(endpointUrl, fileProvider).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.uploadMembersdocEndPoint(fileProvider));
      }));
  }
  getQuotationPremiumSummaryEndPoint<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._getQuotationPremiumSummaryUrl}?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getQuotationPremiumSummaryEndPoint(quotationId));
      }));
  }
  generateQuotationPremiumSummaryEndPoint<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._generateQuotationPremiumSummaryUrl}?quotationId=${quotationId}`;

    return this.http.get(endpointUrl, this.getExcelDownloadHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.generateQuotationPremiumSummaryEndPoint(quotationId));
      }));
  }
  generateQuotationSOBTrackerEndPoint<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._generateQuotationSOBTrackerUrl}?quotationId=${quotationId}`;

    return this.http.get(endpointUrl, this.getExcelDownloadHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.generateQuotationSOBTrackerEndPoint(quotationId));
      }));
  }
  generateQuotationTechnicalSheetEndPoint<T>(quotationId: number, categoryId: number): Observable<T> {
    let endpointUrl = `${this._generateQuotationTechnicalSheetUrl}?quotationId=${quotationId}&categoryId=${categoryId}`;

    return this.http.get(endpointUrl, this.getExcelDownloadHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.generateQuotationTechnicalSheetEndPoint(quotationId, categoryId));
      }));
  }
  getPolicyHolders(tenantId: number): CustomStore {
    return AspNetData.createStore({
      loadParams: { tenantId: tenantId },
      loadUrl: this._getPolicyHolderListUrl,
      onBeforeSend: this.getAuthHeader_devextreme,
      // onBeforeSend: (method, ajaxOptions)=>{
      //   ajaxOptions.headers = this.getRequestHeaders();
      // },
      errorHandler: (error) => {
        this.handleError_devextreme(error);
      }
    });
  }
  saveplandesignfactorrates<T>(data: any): Observable<T> {
    return this.http.post<T>(this._savePlanDesignFactorRatesUrl, data, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.saveplandesignfactorrates(data));
      }));
  }
  getBusinessEntities(entityType: string, tenantId: number): CustomStore {
    return AspNetData.createStore({
      loadParams: { entityType: entityType, tenantId: tenantId },
      key: "id",
      loadUrl: this._getBusinessEntitiesUrl,
      onBeforeSend: this.getAuthHeader_devextreme,
      errorHandler: (error) => {
        this.handleError_devextreme(error);
      }
    });

  }


  getUserRoles<T>(tenantId: number, userid: string): Observable<T> {
    let endpointUrl = `${this._sharedgetuserrolesUrl}${tenantId}/${userid}`;

    // var header = this.getRequestHeaders();
    // header.withCredentials = true;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getUserRoles(tenantId, userid));
      }));
  }


  // getBusinessSectorList(tenantId: number): CustomStore {
  //     return AspNetData.createStore({
  //         key: "id",
  //         loadParams: { tenantId: tenantId },
  //         loadUrl: this._businessSectorUrl,
  //         onBeforeSend: this.getAuthHeader_devextreme,
  //         errorHandler: function (error) {
  //           this.handleError_devextreme(error);
  //         }
  //     });
  // }
  getAllQuotationList(tenantId: number): CustomStore {
    return AspNetData.createStore({
      key: "quotationId",
      loadParams: { tenantId: tenantId },
      loadUrl: this._getAllQuotationsUrl,
      onBeforeSend: this.getAuthHeader_devextreme,
      errorHandler: (error) => {
        this.handleError_devextreme(error);
      }
    });

  }



  getFilterAllQuotationList(tenantId: number, policyTypes: any[]): CustomStore {
    return AspNetData.createStore({
      key: "quotationId",
      loadParams: { tenantId: tenantId, policyTypes: policyTypes },
      loadUrl: this._getFilterAllQuotationsUrl,
      onBeforeSend: this.getAuthHeader_devextreme,
      errorHandler: (error) => {
        this.handleError_devextreme(error);
      }
    });
  }

  getquotationIndividualPlans<T>(quotationId: number): Observable<T> {

    let endpointUrl = `${this._getquotationIndividualPlansUrl}?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getQuotationTaskAssignToEndPoint(quotationId));
      }));

  }




  getFilterPendingQuotationList(tenantId: number, policyTypes: any[]): CustomStore {
    return AspNetData.createStore({
      key: "quotationId",
      loadParams: { tenantId: tenantId, policyTypes: policyTypes },
      loadUrl: this._getFilterPendingQuotationsUrl,
      onBeforeSend: this.getAuthHeader_devextreme,
      errorHandler: (error) => {
        this.handleError_devextreme(error);
      }
    });
  }
  getPendingQuotationList(tenantId: number): CustomStore {
    return AspNetData.createStore({
      key: "quotationId",
      loadParams: { tenantId: tenantId },
      loadUrl: this._getPendingQuotationsUrl,
      onBeforeSend: this.getAuthHeader_devextreme,
      errorHandler: (error) => {
        this.handleError_devextreme(error);
      }
    });
  }
  getFilterMyDraftQuotationList(tenantId: number, policyTypes: any[]): CustomStore {
    return AspNetData.createStore({
      key: "quotationId",
      loadParams: { tenantId: tenantId, policyTypes: policyTypes },
      loadUrl: this._getFilterDraftQuotationsUrl,
      onBeforeSend: this.getAuthHeader_devextreme,
      errorHandler: (error) => {
        this.handleError_devextreme(error);
      }
    });
  }
  getMyDraftQuotationList(tenantId: number): CustomStore {
    return AspNetData.createStore({
      key: "quotationId",
      loadParams: { tenantId: tenantId },
      loadUrl: this._getDraftQuotationsUrl,
      onBeforeSend: this.getAuthHeader_devextreme,
      errorHandler: (error) => {
        this.handleError_devextreme(error);
      }
    });
  }
  getQuotationTaskAssignToEndPoint<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._getQuotationTaskAssignmentUrl}?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getQuotationTaskAssignToEndPoint(quotationId));
      }));
  }
  submitQuotationTaskAssignToEndPoint<T>(taskAssignment: Observable<T>): Observable<T> {
    let endpointUrl = `${this._submitQuotationTaskAssignmentUrl}`;

    return this.http.post<T>(endpointUrl, JSON.stringify(taskAssignment), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.submitQuotationTaskAssignToEndPoint(taskAssignment));
      }));
  }
  getActivePlanDesignFactors<T>(f: Observable<T>): Observable<T> {
    let endpointUrl = `${this._getActivePlanDesignFactorsUrl}`;

    return this.http.post<T>(endpointUrl, JSON.stringify(f), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getActivePlanDesignFactors(f));
      }));
  }

  getFutureEffectivePlanDesignFactors<T>(f: Observable<T>): Observable<T> {
    let endpointUrl = `${this._getFutureEffectivePlanDesignFactorsUrl}`;

    return this.http.post<T>(endpointUrl, JSON.stringify(f), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getFutureEffectivePlanDesignFactors(f));
      }));
  }

  deletePlanDesignFactorRate<T>(id: any): Observable<T> {
    let endpointUrl = `${this._deletePlanDesignFactorRateUrl}/${id}`;

    return this.http.delete<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.deletePlanDesignFactorRate(id));
      }));
  }

  updatePlanDesignFactorRate<T>(rate: any): Observable<T> {
    return this.http.post<T>(this._updatePlanDesignFactorRateUrl, rate, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.updatePlanDesignFactorRate(rate));
      }));
  }

  cancelFutureEffectivePlanDesignFactors<T>(payload: any): Observable<T> {
    let endpointUrl = `${this._cancelFutureEffectivePlanDesignFactorsUrl}`;

    return this.http.post<T>(endpointUrl, payload, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.cancelFutureEffectivePlanDesignFactors(payload));
      }));
  }



  getHistocialQuotes(tenantId: number, policyholder: string, tradeLicense: string): Observable<any> {
    let endpointUrl = `${this._getHistoricalQuoteListUrl}?tenantId=${tenantId}&policyholder=${policyholder}&tradeLicense=${tradeLicense}`;

    return this.http.get(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getHistocialQuotes(tenantId, policyholder, tradeLicense));
      }));
  }
  exportClaimInfoEndpoint(quotationId: number): Observable<any> {
    let endpointUrl = `${this._exportClaimInfoUrl}?quotationId=${quotationId}`;

    return this.http.get(endpointUrl, this.getExcelDownloadHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.exportClaimInfoEndpoint(quotationId));
      }));
  }

  downloadTOBEndpoint(quotationId: number): Observable<any> {
    let endpointUrl = `${this._downloadTOBDocUrl}?quotationId=${quotationId}`;

    return this.http.get(endpointUrl, this.getPdfDownloadHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.downloadTOBEndpoint(quotationId));
      }));
  }
  downloadPremiumEndpoint(quotationId: number): Observable<any> {
    let endpointUrl = `${this._downloadPremuimDocUrl}?quotationId=${quotationId}`;

    return this.http.get(endpointUrl, this.getPdfDownloadHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.downloadPremiumEndpoint(quotationId));
      }));
  }
  downloadPremiumTobDocEndpoint(quotationId: number): Observable<any> {
    let endpointUrl = `${this._downloadPremiumTobDocUrl}?quotationId=${quotationId}`;

    return this.http.get(endpointUrl, this.getPdfDownloadHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.downloadPremiumTobDocEndpoint(quotationId));
      }));
  }
  downloadRiderTPADocument(quotationId: number): Observable<any> {
    let endpointUrl = `${this._downloadRiderTPADocUrl}?quotationId=${quotationId}`;

    return this.http.get(endpointUrl, this.getExcelDownloadHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.downloadRiderTPADocument(quotationId));
      }));
  }
  downloadExcelPremium(quotationId: number): Observable<any> {
    let endpointUrl = `${this._downloadExcelPremiumUrl}?quotationId=${quotationId}`;

    return this.http.get(endpointUrl, this.getExcelDownloadHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.downloadExcelPremium(quotationId));
      }));
  }
  downloadDocumentEndpoint(docId: number): Observable<any> {
    let endpointUrl = `${this._downloadDocUrl}?docId=${docId}`;
    return this.http.get(endpointUrl, this.getPdfDownloadHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.downloadDocumentEndpoint(docId));
      }));
  }
  downloadZipEndpoint<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._downloadZipUrl}?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getZipDownloadHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.downloadZipEndpoint(quotationId));
      }));
  }
  downlaodMAFdocEndPoint(docId: number): Observable<any> {
    let endpointUrl = `${this._downloadMafDocUrl}?docId=${docId}`;
    return this.http.get(endpointUrl, this.getPdfDownloadHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.downlaodMAFdocEndPoint(docId));
      }));
  }
  downlaodMAFMemberdocEndPoint(memberId: number): Observable<any> {
    let endpointUrl = `${this._downlaodMAFMemberdocUrl}?memberId=${memberId}`;
    return this.http.get(endpointUrl, this.getPdfDownloadHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.downlaodMAFMemberdocEndPoint(memberId));
      }));
  }
  downloadDocByTypeByFileEndpoint(quotationId: number, docTypeId: number, fileId: number): Observable<any> {
    let endpointUrl = `${this._downloadDefPremiumDocUrl}?quotationId=${quotationId}&docType=${docTypeId}&fileNo=${fileId}`;

    return this.http.get(endpointUrl, this.getPdfDownloadHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.downloadDocByTypeByFileEndpoint(quotationId, docTypeId, fileId));
      }));
  }

  getQuotationClaimExpEndpoint<T>(quotationId: number): Observable<any> {
    let endpointUrl = `${this._getClaimExpUrl}?quotationId=${quotationId}`;

    return this.http.get(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getQuotationClaimExpEndpoint(quotationId));
      }));
  }
  getInsurerQuotationClaimExpSummary<T>(quotationId: number): Observable<any> {
    let endpointUrl = `${this._getInsurerQuotationClaimExpSummaryUrl}?quotationId=${quotationId}`;

    return this.http.get(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getInsurerQuotationClaimExpSummary(quotationId));
      }));
  }
  getSubmitClaimExpEndpoint<T>(obj: any): Observable<T> {

    return this.http.post<T>(this._submitClaimExpUrl, JSON.stringify(obj), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getSubmitClaimExpEndpoint(obj));
      }));
  }
  getQuotationClaimExpSummary<T>(quotationId: number): Observable<any> {
    let endpointUrl = `${this._getquotationClaimExpSummaryUrl}?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getQuotationClaimExpSummary(quotationId));
      }));
  }
  getNRPLoading<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._getNRPLoadingUrl}?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getNRPLoading(quotationId));
      }));

  }
  getApprovalRequestEndPoint<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._getApprovalRequestUrl}?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getApprovalRequestEndPoint(quotationId));
      }));
  }
  getInsurerApprovalRequestEndPoint<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._getInsurerApprovalRequestUrl}?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getInsurerApprovalRequestEndPoint(quotationId));
      }));
  }
  submitApprovalDecisionEndPoint<T>(obj: any): Observable<T> {
    return this.http.post<T>(this._submitApprovalDecisionUrl, JSON.stringify(obj), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.submitApprovalDecisionEndPoint(obj));
      }));
  }
  submitInsurerApprovalDecisionEndPoint<T>(obj: any): Observable<T> {
    return this.http.post<T>(this._submitInsurerApprovalDecisionUrl, JSON.stringify(obj), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.submitInsurerApprovalDecisionEndPoint(obj));
      }));
  }
  updatecategoryloadingEndPoint<T>(obj: any): Observable<T> {
    return this.http.post<T>(this._updatecategoryloadingsUrl, JSON.stringify(obj), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.updatecategoryloadingEndPoint(obj));
      }));
  }

  getQuotationDocuments<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._getquotationDocumentsUrl}?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getQuotationDocuments(quotationId));
      }));
  }
  getQuotationDocumentsByType<T>(quotationId: number, docTypeId: string): Observable<T> {
    let endpointUrl = `${this._getquotationDocsByTypeUrl}?quotationId=${quotationId}&docTypeId=${docTypeId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getQuotationDocumentsByType(quotationId, docTypeId));
      }));
  }
  getMemberQuotationDocumentsByType<T>(quotationId: number, docTypeId: string, memberId: number): Observable<T> {
    let endpointUrl = `${this._getMemberQuotationDocumentsByTypeUrl}?quotationId=${quotationId}&docTypeId=${docTypeId}&memberId=${memberId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getQuotationDocumentsByType(quotationId, docTypeId));
      }));
  }
  deleteDocument<T>(quotationId: number, docId: number): Observable<T> {
    let endpointUrl = `${this._deleteDocumentUrl}`;

    // var obj = {quotationId:quotationId,docId:docId}
    return this.http.post<T>(endpointUrl,
      JSON.stringify({ quotationId: quotationId, docId: docId }),
      this.getRequestHeaders()).pipe<T>(
        catchError(error => {
          return this.handleError(error, () => this.deleteDocument(quotationId, docId));
        }));
  }
  deleteApprovalDocument<T>(quotationId: number, docId: number): Observable<T> {
    let endpointUrl = `${this._deleteApprovalDocumentUrl}`;

    // var obj = {quotationId:quotationId,docId:docId}
    return this.http.post<T>(endpointUrl,
      JSON.stringify({ quotationId: quotationId, docId: docId }),
      this.getRequestHeaders()).pipe<T>(
        catchError(error => {
          return this.handleError(error, () => this.deleteApprovalDocument(quotationId, docId));
        }));
  }

  deleteMembersDocument<T>(quotationId: number, docId: number): Observable<T> {
    let endpointUrl = `${this._deleteMembersDocumentUrl}`;
    // var obj = {quotationId:quotationId,docId:docId}
    return this.http.post<T>(endpointUrl,
      JSON.stringify({ quotationId: quotationId, docId: docId }),
      this.getRequestHeaders()).pipe<T>(
        catchError(error => {
          return this.handleError(error, () => this.deleteMembersDocument(quotationId, docId));
        }));
  }


  deleteQuotation<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._deleteQuotationUrl}`;
    return this.http.post<T>(endpointUrl, JSON.stringify(quotationId), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.deleteQuotation(quotationId));
      }));
  }
  regenerateQuotationDoc<T>(quotationNo: string, isComputePremium: boolean): Observable<T> {
    let endpointUrl = `${this._regenerateQuotationDocUrl}`;
    // tslint:disable-next-line: max-line-length
    return this.http.post<T>(endpointUrl, JSON.stringify({ quotationNo: quotationNo, isComputePremium: isComputePremium }), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.regenerateQuotationDoc(quotationNo, isComputePremium));
      }));
  }
  confirmQuotation<T>(quotationId: number): Observable<T> {
    return this.http.post<T>(this._confirmQuotationUrl, JSON.stringify(quotationId), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.confirmQuotation(quotationId));
      }));
  }
  checkNewOptionAllowed<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._checkNewOptionUrl}?quotationId=${quotationId}`;
    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.checkNewOptionAllowed(quotationId));
      }));
  }
  lostQuotation<T>(obj: number): Observable<T> {
    return this.http.post<T>(this._lostQuotationUrl, JSON.stringify(obj), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.lostQuotation(obj));
      }));
  }
  getQuotationApprovalComment<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._quotationApprovalCommentUrl}?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.getQuotationApprovalComment(quotationId));
      }));
  }
  validateMafQuestionaries<T>(quotationId: number, hasDisclairmer: boolean): Observable<T> {
    let endpointUrl = `${this._validateMafQuestionariesUrl}?quotationId=${quotationId}&hasDisclairmer=${hasDisclairmer}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => {
        return this.handleError(error, () => this.validateMafQuestionaries(quotationId, hasDisclairmer));
      }));
  }
  escalateToReviewQuotation<T>(escalate: Object): Observable<T> {
    let endpointUrl = `${this._escalateToReviewUrl}`;

    return this.http.post<T>(endpointUrl, JSON.stringify(escalate), this.getRequestHeaders()).pipe<T>(
      catchError(error => { return this.handleError(error, () => this.escalateToReviewQuotation(escalate)); }
      ));
  }
  getSubProducts<T>(productId: number): Observable<T> {
    let endpointUrl = `${this._getSubProductsUrl}?productId=${productId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => { return this.handleError(error, () => this.getSubProducts(productId)); }
      ));
  }
  getSubProductsMap<T>(quotationId: number): Observable<T> {
    let endpointUrl = `${this._getSubProductsMapUrl}?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => { return this.handleError(error, () => this.getSubProductsMap(quotationId)); }
      ));
  }

  getProudctCatRules(quotationId: number): Observable<ProductCategoryRule[]> {
    let endpointUrl = `${this._getProductCatRulesUrl}?quotationId=${quotationId}`;
    return this.http.get<ProductCategoryRule[]>(endpointUrl, this.getRequestHeaders()).pipe(
      catchError(error => this.handleError(error, () => this.getProudctCatRules(quotationId)))
    );
  }

  getBenefitPlans<BenefitPlansDto>(quotationId: number): Observable<BenefitPlansDto> {
    let endpointUrl = `${this._getBenefitPlansUrl}?quotationId=${quotationId}`;

    return this.http.get<BenefitPlansDto>(endpointUrl, this.getRequestHeaders()).pipe<BenefitPlansDto>(
      catchError(error => { return this.handleError(error, () => this.getBenefitPlans(quotationId)); }
      ));
  }

  getRegions<T>(): Observable<T> {
    let endpointUrl = `${this._getRegionsUrl}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => { return this.handleError(error, () => this.getRegions()); }
      ));
  }
  getSubProductRegionMap<T>(productId: number): Observable<T> {
    let endpointUrl = `${this._getSubProductRegionMapUrl}?productId=${productId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => { return this.handleError(error, () => this.getSubProductRegionMap(productId)); }
      ));
  }
  getChronicConditionValues<T>(): Observable<T> {
    let endpointUrl = this._chronicConditionValueUrl;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getChronicConditionValues());
      }));
  }
  getChronicSubLimit<T>(): Observable<T> {
    let endpointUrl = this._chronicSubmLimitUrl;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getChronicSubLimit());
      }));
  }
  updateChronicConditionEndPoint<T>(chronicObject: Observable<T>): Observable<T> {
    let endpointUrl = `${this._updatechronicConditionUrl}`;

    return this.http.post<T>(endpointUrl, JSON.stringify(chronicObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.updateChronicConditionEndPoint(chronicObject));
      }));
  }

  getQuotationChronicConditions<T>(quotationId: number): Observable<T> {
    let endpointUrl = this._quoteChronicConditionUrl + `?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getQuotationChronicConditions(quotationId));
      }));
  }
  updateShortMAFEndPoint<T>(mafObject: Observable<T>): Observable<T> {
    let endpointUrl = `${this._updateShortMAFUrl}`;

    return this.http.post<T>(endpointUrl, JSON.stringify(mafObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.updateShortMAFEndPoint(mafObject));
      }));
  }
  updateShortMAFConditionEndPoint<T>(mafObject: Observable<T>): Observable<T> {
    let endpointUrl = `${this._updateShortMAFConditionUrl}`;

    return this.http.post<T>(endpointUrl, JSON.stringify(mafObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.updateShortMAFConditionEndPoint(mafObject));
      }));
  }
  updateMemberRemarksValues<T>(reamrkObject: any): Observable<T> {
    let endpointUrl = `${this._updateMemberRemarksValuesUrl}`;

    return this.http.post<T>(endpointUrl, JSON.stringify(reamrkObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.updateMemberRemarksValues(reamrkObject));
      }));
  }
  UpdateMemberRemarksByUW<T>(reamrkObject: any): Observable<T> {
    let endpointUrl = `${this._updateMemberRemarksByUWUrl}`;

    return this.http.post<T>(endpointUrl, JSON.stringify(reamrkObject), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.UpdateMemberRemarksByUW(reamrkObject));
      }));
  }
  getQuotationShortMAFEndPoint<T>(quotationId: number): Observable<T> {
    let endpointUrl = this._quoteShortMAFUrl + `?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getQuotationShortMAFEndPoint(quotationId));
      }));
  }
    getQuotationShortMAFMemberReviewEndPoint<T>(quotationId: number): Observable<T> {
    let endpointUrl = this._quoteShortMAFReviewUrl + `?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getQuotationShortMAFMemberReviewEndPoint(quotationId));
      }));
  }
  getQuotationComments<T>(quotationId: number): Observable<T> {
    let endpointUrl = this._quoteCommentsUrl + `?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getQuotationComments(quotationId));
      }));
  }
  getOverrideComments<T>(quotationId: number): Observable<T> {
    let endpointUrl = this._overrideCommentsUrl + `?quotationId=${quotationId}`;

    return this.http.get<T>(endpointUrl, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getOverrideComments(quotationId));
      }));
  }
  getsurveylink<T>(quotationId: any): Observable<T> {
    let endpointUrl = `${this._getsurveylinkUrl}`;

    return this.http.post<T>(endpointUrl, JSON.stringify(quotationId), this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getsurveylink(quotationId));
      }));
  }
  getAgeBandPremiumPP<T>(quotationId: number, categoryId: number): Observable<T> {

    const params = new HttpParams().set('quotationId', quotationId).set('categoryId', categoryId);

    const httpOptions = { headers: this.getRequestHeaders().headers, params: params };

    let endpointUrl = this._getAgeBandPremiumPPUrl; //+ `?quotationId=${quotationId}&categoryId=${categoryId}`;

    return this.http.get<T>(endpointUrl, httpOptions).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getAgeBandPremiumPP(quotationId, categoryId));
      }));
  }
  sendAPIRequest<T>(quotationId: number, categoryId: number, url: string, method: string, data: any = {}): Observable<T> {
    let result;
    let endpointUrl = this._tobParameterUrl + url;
    const params = new HttpParams({ fromObject: data });

    const httpOptions = { headers: this.getRequestHeaders().headers, body: params };

    switch (method) {
      case 'GET':
        endpointUrl = endpointUrl + `?quotationId=${quotationId}&categoryId=${categoryId}`;
        result = this.http.get<T>(endpointUrl, httpOptions).pipe<T>(
          catchError(error => {
            return this.handleError(error, () => this.sendAPIRequest(quotationId, categoryId, url, method, data));
          }));
        break;
      case 'PUT':
        endpointUrl = endpointUrl + `?quotationId=${quotationId}&categoryId=${categoryId}`;
        result = this.http.put(endpointUrl, data, httpOptions);
        break;
      case 'POST':
        endpointUrl = endpointUrl + `?quotationId=${quotationId}&categoryId=${categoryId}`;
        result = this.http.post(endpointUrl, data, httpOptions);
        break;
      case 'DELETE':
        endpointUrl = endpointUrl + "/" + data
        result = this.http.delete(endpointUrl, { headers: this.getRequestHeaders().headers });
        break;
    }
    return result.toPromise()
      .then((data: any) => (method === 'GET' ? data.data : data))
      .catch((e) => {
        throw e && e.error && e.error.Message;
      });
  }

  getBrokerUserAuthorityList<T>(insurerid: string, brokerid: string): Observable<T> {
    const params = new HttpParams().set('insurerid', insurerid).set('brokerid', brokerid);
    const httpOptions = { headers: this.getRequestHeaders().headers, params: params };
    return this.http.get<T>(this._getBrokerUserAuthorityListUrl, httpOptions).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.getBrokerUserAuthorityList(insurerid, brokerid));
      }));
  }
  // BaseRate methods
  getActiveBaseRates<T>(payload: any): Observable<T> {
    return this.http.post<T>(this._getActiveBaseRatesUrl, payload, this.getRequestHeaders()).pipe<T>(
      catchError(error => this.handleError(error, () => this.getActiveBaseRates(payload))));
  }

  saveBaseRates<T>(payload: any): Observable<T> {
    return this.http.post<T>(this._saveBaseRatesUrl, payload, this.getRequestHeaders()).pipe<T>(
      catchError(error => this.handleError(error, () => this.saveBaseRates(payload))));
  }

  getFutureEffectiveBaseRates<T>(payload: any): Observable<T> {
    return this.http.post<T>(this._getFutureEffectiveBaseRatesUrl, payload, this.getRequestHeaders()).pipe<T>(
      catchError(error => this.handleError(error, () => this.getFutureEffectiveBaseRates(payload))));
  }
  cancelFutureEffectiveBaseRates<T>(payload: any): Observable<T> {
    let endpointUrl = `${this._cancelFutureEffectiveBaseRatesUrl}`;
    return this.http.post<T>(endpointUrl, payload, this.getRequestHeaders()).pipe<T>(
      catchError(error => this.handleError(error, () => this.cancelFutureEffectiveBaseRates(payload))));
  }
  updateBaseRate<T>(rate: any): Observable<T> {
    return this.http.post<T>(this._updateBaseRateUrl, rate, this.getRequestHeaders()).pipe<T>(
      catchError(error => {
        return this.handleError(error, () => this.updateBaseRate(rate));
      }));
  }
}